import React from 'react'

import {
  LogOut,
  User,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { DropdownMenu } from './ui/dropdown-menu';
import Dropdown from './ui/dropdown';
const Header = ({user, cart, lowStockItems, onLogout}) => {
  return (
    <>
        <header className="bg-white border-b-4 shadow-lg border-[#FFC20E]">
            <div className="container px-6 py-4 mx-auto">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-white border-2 border-[#FFC20E] rounded-lg">
                    <img src="/logo.png" alt="CWC Logo" className="w-auto h-16" />
                  </div>
                  <div>
                    <h1 className="text-3xl font-bold text-gray-800">
                      CAMSUR WATERSPORT COMPLEX
                    </h1>
                    <p className="font-medium text-cwc-goldDark">
                      Point of Sale System
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="flex items-center space-x-2">
                    <User className="w-4 h-4 text-gray-600" />
                    <span className="text-sm text-gray-600">{user.full_name}</span>
                    <Badge variant="outline">{user.role}</Badge>
                  </div>
                  <div id="dropdown-container" class="relative inline-block text-left">
                    {/* Dropdown menu can be implemented here */}
                    <Dropdown 
                        // The trigger prop defines what opens the menu. Here we use 'Notifications'.
                        trigger={<svg fill="#000000" width="15px" height="15px" viewBox="-3 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-bell"><path d='M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A6.987 6.987 0 0 0 2.29 15h13.42a6.987 6.987 0 0 0-2.044-3.218zM12 17a3 3 0 0 1-6 0H0a8.978 8.978 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.978 8.978 0 0 1 18 17h-6zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1z'/></svg>}
                        // Your original Tailwind classes are applied to the menu panel
                        className="right-0 w-56" 
                      >
                        <Dropdown.Item 
                          onClick={() => console.log('Notification clicked')}
                          className="text-gray-700"
                        >
                          No new notifications
                        </Dropdown.Item>
                        
                        <Dropdown.Item 
                          onClick={() => alert('Viewing settings!')}
                        >
                          Settings
                        </Dropdown.Item>
                      </Dropdown>
                  </div>
                  <Badge variant="outline" className="text-black border-[#FFC20E]">
                    Cart: {cart.length} items
                  </Badge>
                  {/* <Badge
                    variant="outline"
                    className="text-orange-600 border-orange-300"
                  >
                    Low Stock: {lowStockItems.length}
                  </Badge> */}
                  <Button onClick={onLogout} variant="outline" size="sm">
                    <LogOut className="w-4 h-4 mr-2" />
                    Logout
                  </Button>
                </div>
              </div>
            </div>
        </header>
    </>
  )
}

export default Header